import React, { useState } from 'react';
import classNames from 'classnames';
import { Button, Col, Card, CardBody } from 'react-bootstrap';
import { AdminStatus, AdminStatusName } from '../constants/AdminStatus';

function AdminsStatusFilter({ onChangeStatus, previousSelectedStatus }) {
  const [selected, setSelected] = useState(previousSelectedStatus || null);

  const handleClick = (status) => {
    setSelected(status);
    onChangeStatus(status);
  };

  const getButtonClass = (status) =>
    classNames(selected !== status ? 'btn-soft-primary' : 'btn-primary');

  return (
    <Col md="12">
      <Card>
        <CardBody>
          <div className="d-flex gap-2 flex-row">
            <Button
              className={classNames('rounded-pill', getButtonClass(null))}
              onClick={() => handleClick(null)}
            >
              All
            </Button>
            {Object.entries(AdminStatus).map(([key, value]) => (
              <Button
                key={key}
                className={classNames('rounded-pill', getButtonClass(value))}
                onClick={() => handleClick(value)}
              >
                {AdminStatusName[key]}
              </Button>
            ))}
          </div>
        </CardBody>
      </Card>
    </Col>
  );
}

export default AdminsStatusFilter;
